// Modules
import React from 'react'
import { Button, Intent } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import PropTypes from 'prop-types'

// Components
import Icon from 'components/brand/icon/Icon'

// Hooks
import useLanguage from 'hooks/system/useLanguage'

// Helpers
import { openSentryPanel } from 'helpers/sentry'

// Constants
import { IS_ON_PREMISE } from 'constants/environment'

// Styles
import './Feedback.scss'

// Component: Utility > Feedback
function Feedback ({ className, style }) {
	// Data
	const { direction, language, translate } = useLanguage('components.utility.feedback')

	// Render
	if (IS_ON_PREMISE || language !== 'en') return null
	return (
		<span
			id="feedback"
			data-utility="feedback"
			className={className}
			style={style}>
			<Tooltip2
				content={translate.local('hint')}
				placement={direction === 'ltr' ? 'left' : 'right'}>
				<Button
					className="aix-trigger"
					intent={Intent.DANGER}
					icon={
						<Icon
							willScale
							name="feedback"
							className="aix-trigger-icon"
							pathColor="var(--light-color)" />
					}
					onClick={() => openSentryPanel()} />
			</Tooltip2>
		</span>
	)
}

// Properties
Feedback.propTypes = {
	className: PropTypes.string,
	style: PropTypes.object
}

// Export
export default Feedback
